import { useMutation } from '@tanstack/react-query'
import { useActions } from '../../store'
import { format } from 'date-fns'
import fileDownload from 'js-file-download'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAffiliation, useAuth } from '../index'

const { env } = window

const useAffiliationUsersExportMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { affiliation } = useAffiliation()
  const { setDisabled, setMessage, progressStart, progressEnd } = useActions()

  const getExport = async (search, sort, userType) => {
    const api = encodeURI(
      `${env.apiUrl}/affiliations/${affiliation.id}/users/export`
    )
    let params = search ? `&search=${search}` : ''
    params += sort.reduce((result, item) => {
      result += `&sort=${item.id}:${item.desc ? 'desc' : 'asc'}`
      return result
    }, '')
    params += userType ? `&userType=${userType}` : ''
    const url = [api, params.slice(1)].join('?')
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.blob()
  }

  return useMutation({
    mutationFn: ({ search, sort, userType }) =>
      getExport(search, sort, userType),
    onMutate: () => {
      progressStart()
      setDisabled(true)
      setMessage('Downloading...')
    },
    onError: (error) => handleError(error, 'Error downloading document'),
    onSuccess: (data) => {
      fileDownload(
        data,
        `${format(new Date(), 'yyyyMMdd-HHmmss')}-${
          affiliation.urlSlug
        }-users.csv`
      )
      setMessage('Document was downloaded')
    },
    onSettled: () => {
      progressEnd()
      setDisabled(false)
    }
  })
}

export { useAffiliationUsersExportMutation }
